/** Resolves the transition only once a DOM condition holds (a sidebar appearing or disappearing). */
export function navigateWithViewTransition(
	onNavigate: () => void,
	/** Checked synchronously, then on every DOM mutation. */
	isReady: () => boolean,
) {
	if (!document.startViewTransition) {
		onNavigate();
		return;
	}

	const transition = document.startViewTransition(() => {
		onNavigate();
		return new Promise<void>((resolve) => {
			// A preloaded route may commit synchronously.
			if (isReady()) {
				resolve();
				return;
			}
			const observer = new MutationObserver(() => {
				if (isReady()) {
					observer.disconnect();
					resolve();
				}
			});
			observer.observe(document.body, { childList: true, subtree: true });
			setTimeout(() => {
				observer.disconnect();
				resolve();
			}, 3000);
		});
	});
	// An aborted/superseded transition rejects `.ready` with InvalidStateError; expected, not actionable (TEC-3546).
	transition.ready.catch(() => {});
}
